import { useCallback, useState } from 'react';
import { useSnackbar } from 'notistack';
import { exportWorklogsExcel } from './apiCalls';

export default (withEquipment) => {
  const [isExported, setIsExported] = useState(null);

  const { enqueueSnackbar } = useSnackbar();

  const onDownload = useCallback(async () => {
    try {
      await exportWorklogsExcel(isExported, withEquipment);
      setIsExported(null)
    } catch (e) {
      enqueueSnackbar('Error creating excel report.', { variant: 'error' });
      console.error(e);
    }
  }, [isExported]);

  return {
    isExported,
    setIsExported,
    onDownload,
  };
};
